import { useEffect, useState } from 'react';

/** Debounce a string value, trimming it. Syncing React state to a setTimeout — valid useEffect per AGENTS.md. */
export function useDebouncedValue(value: string, ms: number): string {
  const [debounced, setDebounced] = useState(value.trim());

  useEffect(() => {
    const handle = setTimeout(() => {
      setDebounced(value.trim());
    }, ms);
    return () => {
      clearTimeout(handle);
    };
  }, [value, ms]);

  return debounced;
}
